<div class="card">
    <img src="./assets/img/not-found.jpg" alt="" class="card-img-top">
</div>